import { render } from "./dsp-nearbyschool.vue?vue&type=template&id=5fe66978"
import script from "./dsp-nearbyschool.js?vue&type=script&lang=js"
export * from "./dsp-nearbyschool.js?vue&type=script&lang=js"

import "./dsp-nearbyschool.vue?vue&type=style&index=0&id=5fe66978&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__